import React from "react";
import styled from "styled-components";
import { constants } from "@thecb/components";
import { noop } from "@/util/common";
import { AI_PRIMARY_HOVER, AI_ACCENT } from "@/constants/colors";

// `$color-accent-text` from styles/_variables.scss, shipped by the design
// system under the same value (WCHK-3048), same token the "View example
// searches" toggle uses.
const { LUCKY_POINT } = constants.colors;

/**
 * ClearFiltersButton
 *
 * The control at the end of the filters list (WCHK-3082). It renders
 * whenever the filters list itself renders, whether that list holds populated
 * filters or not — the page decides that, not this component. A click hands
 * off to the page's clear handler; this component owns no state of its own.
 */
const Button = styled.button`
  flex-shrink: 0;
  padding: 4px 8px;
  background: transparent;
  border: none;
  font-size: 0.875rem;
  font-family: inherit;
  line-height: 1.4;
  color: ${LUCKY_POINT};
  white-space: nowrap;
  cursor: pointer;
  /* A disabled button keeps its colors: the host dims the whole row. */
  &:disabled {
    cursor: default;
  }
  &:hover:not(:disabled) {
    color: ${AI_PRIMARY_HOVER};
  }
  &:focus-visible,
  &:focus {
    outline: 2px solid ${AI_ACCENT};
    outline-offset: 2px;
  }
`;

const ClearFiltersButton = ({
  onClick = noop,
  dataQa = "nl-clear-filters",
  disabled = false,
}) => (
  <Button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-qa={dataQa}
    data-testid={dataQa}
  >
    Clear filters
  </Button>
);

export default ClearFiltersButton;
